var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXsollaId(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.112 8.502c-2.142-.535-2.812-1.105-3.414-2.979C21.556 1.908 19.247 0 16 0c-3.247 0-5.556 1.908-6.695 5.523-.602 1.874-1.272 2.444-3.414 2.98C2.243 9.405 0 11.915 0 15.262c0 3.348 2.243 5.858 5.891 6.762 2.142.536 2.812 1.105 3.414 2.98 1.139 3.614 3.448 5.522 6.695 5.522 3.247 0 5.556-1.908 6.695-5.523.602-1.874 1.271-2.443 3.414-2.979C29.757 21.121 32 18.611 32 15.264c0-3.348-2.243-5.858-5.891-6.762h.003zm-4.857 11.916c-2.209 0-4.15-1.606-4.619-3.581h-1.205c-.502 1.941-2.444 3.581-4.653 3.581-2.644 0-4.786-2.175-4.786-4.82a4.786 4.786 0 014.786-4.786c2.176 0 4.15 1.606 4.653 3.548h1.205c.502-1.975 2.444-3.548 4.62-3.548 2.644 0 4.82 2.142 4.82 4.786 0 2.645-2.176 4.82-4.82 4.82z",
    fill: "#80EAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.197 13.69h-3.85v3.85h3.85v-3.85zM12.72 13.69H8.87v3.85h3.85v-3.85z",
    fill: "#80EAFF"
  })));
}

export default SvgXsollaId;